"use client";

import { SwiperSlide } from "swiper/react";
import SwiperCarousel from "@/components/plugins/swiper/SwiperCarousel";
import TextSubHeader from "@/components/typography/TextSubHeader";
import TextHeader from "@/components/typography/TextHeader";
import TextContent from "@/components/typography/TextContent";
import SwiperSlideImage from "@/components/plugins/swiper/SwiperSlideImage";

import imgSlide1Map from "@/assets/images/screens/homepage/location-pros-1.jpg";
import imgSlide2Map from "@/assets/images/screens/homepage/location-pros-2.jpg";
import imgSlide3Map from "@/assets/images/screens/homepage/location-pros-3.jpg";
import imgSlide4Map from "@/assets/images/screens/homepage/location-pros-4.jpg";
import imgSlide5Map from "@/assets/images/screens/homepage/location-pros-5.jpg";

import imgSlide1 from "@/assets/images/screens/homepage/comfort-pros-1.jpg";
import imgSlide4 from "@/assets/images/screens/homepage/comfort-pros-4.jpg";
// import imgSlide2 from "@/assets/images/screens/homepage/comfort-pros-2.jpg";
import imgSlide3 from "@/assets/images/screens/homepage/comfort-pros-3.jpg";
import DrawComfortPros from "@/screens/homepage/components/drawings/DrawComfortPros";

export default function ComfortPros() {
  const slides = [
    ...[
      {
        image: imgSlide1Map,
        content: "100 m w linii prostej od stoku Beskid Sport Arena",
      },
      {
        image: imgSlide2Map,
        content:
          "Unikalny archtektonicznie kompleks współgrający z naturalnym krajobrazem",
      },
      {
        image: imgSlide3Map,
        content: "228 apartamentów o pow. od 25-50 m2 z tarasami",
      },
      {
        image: imgSlide4Map,
        content:
          "Niepowtarzalna koncepcja i wzornictwo dopracowane w każdym detalu",
      },
      {
        image: imgSlide5Map,
        content: "Dwupoziomowa przestrzeń wspólna z panoramicznym widokiem",
      },
    ],
    ...[
      {
        image: imgSlide1,
        content: "Do każdego pokoju – taras ze wspaniałym widokiem na Beskidy",
      },
      {
        image: imgSlide4,
        content: "Kolory, światło i detale tworzą klimat wypoczynku.",
      },
      // {
      //   image: imgSlide2,
      //   content: "Każdy apartament wyposażony w aneks kuchenny",
      // },
      {
        image: imgSlide3,
        content: "Ekskluzywne i unikalne materiały wnętrzarskie",
      },
    ],
  ];

  return (
    <div className="pb-16 pt-12 lg:pb-24 lg:pt-24">
      <div className="mb-16 lg:mb-24">
        <div className="m-auto max-w-screen-sm px-5">
          <div className="relative z-10">
            <TextSubHeader>
              <h2>Apartamenty inwestycyjne w Szczyrku</h2>
            </TextSubHeader>
            <TextHeader>
              <span className="relative inline-block">
                <span className="relative z-10">Gwarancja</span>
                <DrawComfortPros className="absolute -inset-x-2 top-0" />
              </span>{" "}
              <span className="relative z-10">komfortu i wygody</span>{" "}
            </TextHeader>
            <TextContent>
              Wyjątkowy design wnętrz, wygodne łóżka w pokojach, przepiękne
              widoki na górskie szczyty, kuchnia serwująca lokalne przysmaki i
              ponadprzeciętna obsługa, która zadba o Twoją wygodę i komfort
              podczas pobytu – to wyróżniki marki Tremonti®.
            </TextContent>
          </div>
        </div>
      </div>
      <SwiperCarousel>
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <SwiperSlideImage image={slide.image}>
              {slide.content}
            </SwiperSlideImage>
          </SwiperSlide>
        ))}
      </SwiperCarousel>
    </div>
  );
}
